export type AccountProfile = {
  features: Record<string, boolean>;
  preferences: Record<string, string>;
  lock_minutes: number;
  revision: number;
  totp_bound: boolean;
  totp_enabled: boolean;
  avatar: boolean;
  password_recovery_ready: boolean;
  totp_recovery_ready: boolean;
};
export type AccountState = {
  locked: boolean;
  interaction_at: string;
  account: AccountProfile;
  initial_mode: "off" | "remind" | "require";
  initial_username_changed: boolean;
  initial_password_changed: boolean;
  auth_source: "local" | "oidc";
  role: string;
};
export type AccountPolicy = {
  oidc_enabled: boolean;
  initial_mode: "off" | "remind" | "require";
  sensitive_verification: boolean;
};
export const optionalFeatures = [
  {
    id: "lock",
    zh: "账户锁屏",
    en: "Workspace lock",
    description: "手动锁屏与按空闲时间自动锁屏；当前浏览器的标签页一起生效。",
  },
  {
    id: "records",
    zh: "历史登录记录",
    en: "Login history",
    description: "查看本人近期登录成功与失败记录，在登录设备下方展示。",
  },
  {
    id: "device_notes",
    zh: "设备备注",
    en: "Device notes",
    description: "为本人登录设备添加、修改和清空备注。",
  },
  {
    id: "password_reset",
    zh: "忘记密码",
    en: "Password recovery",
    description:
      "先保存独立恢复凭据，启用后才可用于密码找回。与 TOTP 恢复码分开。",
  },
  {
    id: "preferences",
    zh: "个人偏好",
    en: "Personal preferences",
    description: "管理本人的主题、语言和显示密度。",
  },
];
